import {Injectable, Injector} from '@angular/core';

import {Observable, Subject} from 'rxjs';
import {HttpService} from 'projects/core/src/public-api';
import {Customer} from './customer';
import {CustomerResponcePage} from './customer-responce-page';
import {ContactInfo} from './contactInfo';
import {Any} from 'json2typescript';
import {WsService} from '../../data/ws.service';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {QbCustomer} from './qb-customer';
import {ShortObject} from '../../project-misc/data/project/short-json-object';
import {CustomerProj} from './customer-in-proj';
import {SearchBody} from '../../search/data/searchBody';
import {ProjectFile} from '../../project-misc/data/project/project-file';
import {HttpEvent} from '@angular/common/http';
import {FileService} from '../../../../../../core/src/lib/misc/data/file/file.service';


export class ContactsObject {
  allContacts?: ContactInfo[]
  selectedContacts?: ContactInfo[]
}

@Injectable({
  providedIn: 'root',
})
export class CustomerService extends HttpService {

  lastContactIndex = new Observable<number>();
  nfsContacts = new Subject<ContactsObject>();

  constructor(
    protected injector: Injector,
    protected appStateQuery: AppStateQuery,
    protected wsService: WsService,
    protected fileService: FileService
  ) {
    super(injector);
  }

  createCustomer(): Observable<Customer> {
    return this.postData(`/customer/create`, {active: true}, Customer);
  }

  createCustomerWithName(name: string): Observable<Customer> {
    return this.postData(`/customer/create`, {
      name,
      active: true
    }, Customer);
  }

  getCustomer(customerId: number): Observable<Customer> {
    return this.getData(`/customer/${customerId}`, Customer);
  }

  getCustomers(page: number, limit: number, active?: boolean): Observable<CustomerResponcePage> {
    if (active) {
      return this.getData(`/customer/list?start=${page}&limit=${limit}&active=${active}`, CustomerResponcePage)
    } else {
      return this.getData(`/customer/list?start=${page}&limit=${limit}`, CustomerResponcePage)
    }
  }

  getKBCustomers(): Observable<ShortObject[]> {
    return this.getData(`/customer/list`, ShortObject)
  }

  getKBCustomersForManager(): Observable<ShortObject[]> {
    return this.getData(`/customer/list/for-manager`, ShortObject)
  }

  getSortedCustomers(page: number, limit: number, active: boolean, asc: boolean, label: string): Observable<CustomerResponcePage> {
    if (active) {
      return this.getData(`/customer/list?start=${page}&limit=${limit}&active=${active}&asc=${asc}&sortBy=${label}`, CustomerResponcePage)
    } else {
      return this.getData(`/customer/list?start=${page}&limit=${limit}&asc=${asc}&sortBy=${label}`, CustomerResponcePage)
    }
  }

  getProjectsByCustomer(customerId: number): Observable<CustomerProj[]> {
    return this.getData(`/project/list/for-customer?customerId=${customerId}`, CustomerProj)
  }

  searchCustomers(reqString: string, start: number, limit: number): Observable<CustomerResponcePage> {
    return this.postData(`/customer/search`, {
      start,
      limit,
      query: reqString
    } as SearchBody, CustomerResponcePage);
  }

  getQBCustomers(): Observable<QbCustomer[]> {
    return this.getData(`/qb/customer/list`, QbCustomer);
  }

  searchActiveCustomers(reqString: string, start: number, limit: number): Observable<CustomerResponcePage> {
    return this.postData(`/customer/search`, {
      start,
      limit,
      query: reqString,
      active: true
    } as SearchBody, CustomerResponcePage);
  }

  saveCustomer(customer: Customer): Observable<Customer> {
    return this.putData('/customer/update', customer, Customer);
  }

  saveContact(contact: ContactInfo): Observable<ContactInfo> {
    return this.putData('/contact-info/save', contact, ContactInfo);
  }

  createContact(customerId: number): Observable<ContactInfo> {
    return this.postData(`/contact-info/new?customerId=${customerId}`, {}, ContactInfo);
  }

  deleteContact(contactId: number): Observable<any> {
    return this.deleteData(`/contact-info/${contactId}/delete`, Any);
  }

  deleteCustomer(customerId: number): Observable<any> {
    return this.deleteData(`/customer/${customerId}`, Any);
  }

  getCustomerFiles(customerId: number): Observable<ProjectFile[]> {
    return this.getData(this.fileService.getListFilesLink('customer', customerId), ProjectFile);
  }

  uploadCustomerFiles(files: File[], customerId: number): Observable<HttpEvent<ProjectFile[]>> {
    return this.fileService.postFile<ProjectFile[]>(this.fileService.getUploadFileLink('customer', customerId), 'files', files);
  }

  deleteCustomerFile(fileId: number, customerId: number): Observable<ProjectFile> {
    return this.deleteData(this.fileService.getDeleteFileLink(customerId), ProjectFile)
  }
}
